import { api } from "../Configurations/axios";

//Post
const CreateProjectHistoryAPI = async (companyId: string, userEmail: string, projectName: string, activities: string, type: number, budget: string, rhValues: string, equipmentValues: string, invoiceValues: string, infraValues: string, inProgress: boolean) => {
    try {

        const result = await api.post('/ProjectHistory/CreateProjectHistory', {
            companyId: companyId,
            userEmail: userEmail,
            projectName: projectName,
            activities: activities,
            type: type,
            budget: budget,
            rhValues: rhValues,
            equipmentValues: equipmentValues,
            invoiceValues: invoiceValues,
            infraValues: infraValues,
            inProgress: inProgress
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//PUT
const EditProjectHistoryAPI = async (projectId: string, userEmail: string, projectName: string, activities: string, budget: string, rhValues: string, equipmentValues: string, invoiceValues: string, infraValues: string, eligibleText: string, companyId: string, inProgress: boolean) => {
    try {
        const result = await api.put('/ProjectHistory/EditProjectHistory', {
            projectId: projectId,
            userEmail: userEmail,
            projectName: projectName,
            activities: activities,
            budget: budget,
            rhValues: rhValues,
            equipmentValues: equipmentValues,
            invoiceValues: invoiceValues,
            infraValues: infraValues,
            eligible: eligibleText,
            companyId: companyId,
            inProgress: inProgress
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutJustificationOnProjectHistoryAPI = async (projectId: string, justification: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put('/ProjectHistory/AddJustificationOnProject', { projectId: projectId, justification: justification, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetProjectHistoryAPI = async (projectId: string) => {
    try {
        const result = await api.get(`/ProjectHistory/GetProject/?projectId=${projectId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllProjectHistoryAPI = async (companyId: string, page: number, take: number, word: string) => {
    try {
        word = word === "" ? "all" : word;
        const result = await api.get(`/ProjectHistory/GetAllProjectHistory/?companyId=${companyId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
       
}


const DeleteProjectHistoryAPI = async (projectId: string, companyId: string) => {
    try {
        const result = await api.delete('/ProjectHistory/DeleteProjectHistory', { data: { projectId: projectId, companyId: companyId } });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const handleUploadProjectHistoryAPI = async (file: Blob, companyId: string, userEmail: string, inProgress: boolean) => {
    try {
        var UploadProjectFileCommand = new FormData()

        UploadProjectFileCommand.append('file', file);
        UploadProjectFileCommand.append('companyId', companyId);
        UploadProjectFileCommand.append('userEmail', userEmail);
        UploadProjectFileCommand.append('inProgress', inProgress.toString());

        const result = await api.post(`/ProjectHistory/UploadExcel`, UploadProjectFileCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }

        });
        const dataFiles = await result.data;
        return dataFiles;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const handleDownloadProjectHistoryModelAPI = async(companyId: string, userEmail: string) => {
    try {
        const result = await api.get(`ProjectHistory/Download/${companyId}/${userEmail}`, {
            responseType: 'blob'
        });
        const response = await result.data;
        return response;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}


export {
    CreateProjectHistoryAPI,
    EditProjectHistoryAPI,
    PutJustificationOnProjectHistoryAPI,
    GetProjectHistoryAPI,
    DeleteProjectHistoryAPI,
    GetAllProjectHistoryAPI,
    handleUploadProjectHistoryAPI,
    handleDownloadProjectHistoryModelAPI
}